import classNames from "classnames";

/**
 * 두 개의 선택지를 가진 세그먼트 컨트롤 컴포넌트
 * @param {object} props
 * @param {Array<{value: string, label: string, checked: boolean, onClick: () => void}>} props.options
 */

interface SegmentedControlProps {
  options: { value: string; label: string; checked: boolean; onClick: () => void }[];
  size?: "sm" | "md" | "lg";
}

const SegmentedControl = ({ options, size = "sm" }: SegmentedControlProps): JSX.Element => {
  const [leftOption, rightOption] = options;

  return (
    <div className={"flex"} role="radiogroup" aria-label="Segmented Control">
      <button
        className={classNames(
          "px-4 py-2 text-base min-w-[80px] border border-solid border-gray-500 rounded-l-lg border-r-0",
          {
            "bg-brand-primary text-white font-bold": leftOption.checked,
            "!min-w-[100px]": size === "md",
            "!min-w-[120px]": size === "lg",
          }
        )}
        role="radio"
        aria-checked={leftOption.checked}
        name="segmented-control"
        value={leftOption.value}
        onClick={leftOption.onClick}
      >
        {leftOption.label}
      </button>
      <button
        className={classNames(
          "px-4 py-2 text-base min-w-[80px] border border-solid border-gray-500 rounded-r-lg border-l-0",
          {
            "bg-brand-primary text-white font-bold": rightOption.checked,
            "!min-w-[100px]": size === "md",
            "!min-w-[120px]": size === "lg",
          }
        )}
        role="radio"
        aria-checked={leftOption.checked}
        name="segmented-control"
        value={rightOption.value}
        onClick={rightOption.onClick}
      >
        {rightOption.label}
      </button>
    </div>
  );
};

SegmentedControl.displayName = "SegmentedControl";
export default SegmentedControl;
